export type StatusType = 'INITIATED' | 'PARTIALLY FAILED' | 'SENT TO ALL' | 'IN PROGRESS' | 'ALL FAILED';

export const statusClassMap: Record<StatusType, string> = {
  INITIATED: 'info',
  'IN PROGRESS': 'info',
  'PARTIALLY FAILED': 'alert',
  'SENT TO ALL': 'success',
  'ALL FAILED': 'error',
};

export const columns = [
  { field: 'createdAt', headerName: 'recruiter:GENERAL.MAILS.date', sorting: true },
  { field: 'mailTemplateId', headerName: 'recruiter:GENERAL.MAILS.templateName', sorting: true },
  { field: 'totalCandidatesSelected', headerName: 'recruiter:GENERAL.MAILS.candidates', sorting: true },
  { field: 'status', headerName: 'recruiter:GENERAL.MAILS.status', sorting: true },
  { field: 'details', headerName: 'recruiter:GENERAL.MAILS.details', sorting: false },
];
